var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 146,
    viewBox: "0 0 148 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.2398 1.74268V82.0809H34.2417C34.2417 82.0809 1.16211 76.1816 1.16211 41.9118C1.16211 7.1543 34.2417 1.74268 34.2417 1.74268",
    fill: "#4F4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7507 171.418V91.0796H137.749C137.749 91.0796 171.478 96.979 170.828 131.249C170.179 165.518 137.749 171.418 137.749 171.418",
    fill: "#4F4E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2666 91.0796V135.023C1.2666 135.023 -1.35472 171.418 46.6757 171.418H81.2283V130.54C81.2283 130.54 82.4114 91.0796 36.3528 91.0796H1.2666Z",
    fill: "#4F4E4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7738 1.74268V45.686C90.7738 45.686 88.1525 82.0809 136.183 82.0809H170.736V41.2034C170.736 41.2034 171.919 1.74268 125.86 1.74268H90.7738Z",
    fill: "#4F4E4E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/big-logo.ce1e798c87ccf60c3f185ffdd3631535.svg";
export { ForwardRef as ReactComponent };